import React, { useEffect, useMemo, useRef, useState } from "react";
import { convertImgJsonToObj, getLogo } from "../common/commonFunctions";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getFileThumbnailDB,
} from "../types/constants";
import { IonIcon } from "@ionic/react";
import { chevronBack, chevronForward, expand } from "ionicons/icons";
import { useAppSelector } from "../app/hooks";
import { mobileWidthBreakpoint } from "../types/form_table_data_types";
import "./../components/styles/ImageRotateStyle.css";
import "./../pages/styles/BussinessHomePage.css";

const ImageArraySlider: React.FC<{
  imageJsonArray: string[];
  imageDataArray?: string[];
  onClick?: (index: number) => void;
  onClickUrlCss?: (url: string, css: string) => void;
  autoSlider?: boolean;
  disableShifter?: boolean;
  disableClick?: boolean;
  removeDisplay?: boolean;
  objectFit?: "cover";
  opacity?: string;
  imgFetchPerc?: string;
  altTag?: string;
  disableExpandButton?: boolean;
  disableScroll?: boolean;
}> = (props) => {
  const totalImages = props.imageJsonArray
    ? props.imageJsonArray.length
    : props.imageDataArray
    ? props.imageDataArray.length
    : 0;
  // const arrayToMap = new Array(totalImages).fill(null);
  const autoSlider = props.autoSlider ? true : false;

  const [intervalVal, setIntervalVal] = useState(null);

  const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
  const touchStartX = useRef(null);
  const handleTouchStart = (event) => {
    if (!!props?.disableScroll) return;
    touchStartX.current = event.touches[0].clientX;
  };

  useEffect(() => {
    if (intervalVal) {
      handleHoverOut(intervalVal);
    }
    if (
      autoSlider &&
      (props.imageJsonArray?.length > 1 || props.imageDataArray?.length > 1)
    ) {
      handleHover();
    }
    return () => {
      handleHoverOut(intervalVal);
    };
  }, [autoSlider, props.imageJsonArray, props.imageDataArray]);

  const baseUrl = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?percentage=${
    props.imgFetchPerc ? props.imgFetchPerc : "40"
  }&Authorization=${API_SECURE_KEY}&`;

  // console.log("Images array ", props.imageJsonArray);
  const imageData: { img: any; css: string }[] = useMemo(() => {
    const retVal: { img: any; css: string }[] = [];
    for (let index = 0; index < totalImages; index++) {
      const imgCont = { img: "", css: "" };
      if (props.imageDataArray && props.imageDataArray[index]) {
        imgCont.img = props.imageDataArray[index];
      } else if (props.imageJsonArray && props.imageJsonArray[index]) {
        const value = convertImgJsonToObj(props.imageJsonArray[index]);
        const imgUrl = `${baseUrl}fileName=${value.fileName}&`;
        imgCont.img = imgUrl;
        imgCont.css = value.imgCss;
      } else {
        imgCont.img = getLogo(true);
      }
      retVal.push(imgCont);
    }
    return retVal;
  }, [props.imageDataArray, props.imageJsonArray, totalImages]);

  const changeIndex = (incr: boolean) => {
    console.log("Called shifter for ", incr);
    if (props.disableShifter) return;
    if (incr) {
      setCurrentImageIndex((prevIndex) => {
        // console.log("Prev state ", prevIndex);
        return (prevIndex + 1) % totalImages;
      });
    } else {
      setCurrentImageIndex((prevIndex) => {
        console.log("Prev state ", prevIndex);
        if (prevIndex === 0) {
          return totalImages - 1;
        } else {
          return prevIndex - 1;
        }
      });
    }
  };

  const handleTouchEnd = (event) => {
    if (!!props?.disableScroll) return;
    if (touchStartX.current !== null) {
      const touchEndX = event.changedTouches[0].clientX;
      const deltaX = touchEndX - touchStartX.current;

      if (deltaX > 50) {
        console.log("swip right");
        changeIndex(false);
      } else if (deltaX < -50) {
        console.log("swip left");
        changeIndex(true);
      }

      touchStartX.current = null;
    }
  };

  const handleHover = () => {
    console.log("Enable auto slider for ");
    const interval = setInterval(() => {
      changeIndex(true);
    }, 2500);
    setIntervalVal(interval);
  };

  const handleHoverOut = (val) => {
    clearInterval(val);
    setCurrentImageIndex(0);
  };
  const isMobile =
    useAppSelector((state) => state.screenWidth).width <= mobileWidthBreakpoint;

  //Component JSX return.
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {imageData.map((imgEl, index) => {
        // const img = props.imageJsonArray
        //   ? props.imageJsonArray[index]
        //   : undefined;
        // const imgDataBuff: string =
        //   props.imageDataArray && props.imageDataArray[index]
        //     ? props.imageDataArray[index]
        //     : undefined;
        // let imgData = "";
        // let value = undefined;
        // //decide on the imgURL as the API or use the data if available
        // if (imgDataBuff) {
        //   imgData = imgDataBuff;
        // } else if (img) {
        //   const value = convertImgJsonToObj(img);
        //   const imgUrl = `${baseUrl}fileName=${value.fileName}&`;
        //   imgData = imgUrl;
        // } else {
        //   imgData = getLogo(true);
        // }

        // const imgData: string =
        //   props.imageDataArray && props.imageDataArray[index]
        //     ? props.imageDataArray[index]
        //     : imgUrl;

        // console.log("Image URL to show ", imgEl);
        return (
          <div key={index}>
            <div
              className={`stakeholder-card-img-wrpr ${imgEl.css} ${
                index === currentImageIndex
                  ? "stakeholder-card-img-wrpr-on-top"
                  : ""
              }`}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
              ref={touchStartX}
              onClick={() => {
                //   expandFunc(index);
                console.log("Click for index ", index);
                if (props.disableClick) return;
                if (props.onClick) props.onClick(currentImageIndex);
                if (props.onClickUrlCss)
                  props.onClickUrlCss(imgEl.img, imgEl.css);
              }}
            >
              {!props.disableExpandButton && (
                <div className="stakeholder-card-img-exapnd_btn">
                  {/* Hello */}
                  <IonIcon icon={expand} />
                </div>
              )}
              <img
                style={{
                  objectFit: props.objectFit ? props.objectFit : "contain",
                  opacity: props.opacity ? props.opacity : "1",
                }}
                key={index}
                src={imgEl.img}
                alt={`${
                  props.altTag
                    ? props.altTag
                    : "VypZee markets online. Explore and shop from your local markets"
                }`}
                className={`stakeholder-card-img ${
                  index === currentImageIndex
                    ? "stakeholder-card-img-wrpr-active"
                    : "stakeholder-card-img-wrpr-inactive"
                }`}
                loading="lazy"
              />
            </div>
            {props.imageJsonArray?.length > 1 &&
              !props.disableShifter &&
              !props.removeDisplay && (
                <div
                  className={`stakeholder-slideNumber`}
                  onClick={(e) => {
                    if (props.disableScroll) return;
                    e.stopPropagation();
                    changeIndex(false);
                  }}
                >
                  <div className="stakeholder-slideNumber-controls">
                    {!isMobile && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <IonIcon icon={chevronBack} />
                        Prev
                      </div>
                    )}
                    <div style={{ textAlign: "center", flexGrow: 1 }}>
                      Image {currentImageIndex + 1} of {totalImages}
                    </div>
                    {!isMobile && (
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        onClick={(e) => {
                          if (props.disableScroll) return;
                          e.stopPropagation();
                          changeIndex(true);
                        }}
                      >
                        Next
                        <IonIcon icon={chevronForward} />
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>
        );
      })}
    </div>
  );
};

export default ImageArraySlider;
